import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { ReportAsk } from '@/features/assistant';
import type { DocumentDetail } from '../api/schemas';
import { ReportPanelTabs, type PanelTab } from './ReportPanelTabs';
import { SummaryTab } from './SummaryTab';
import { WhatChangedTab } from './WhatChangedTab';

type Props = {
  doc: DocumentDetail;
  tab: PanelTab;
  changes: number;
  onTab: (tab: PanelTab) => void;
  onOpen: (page: number, passage?: string | null) => void;
};

const PANEL_WIDTH = 400;

/** Beside the PDF: Ask (this report only), the summary, and what it revised. */
export function ReportPanel({ doc, tab, changes, onTab, onOpen }: Props) {
  const toPage = (p: number) => { onOpen(p); };
  return (
    <Stack component="aside" aria-label="About this report" sx={panelSx}>
      <ReportPanelTabs value={tab} changes={changes} onChange={onTab} />
      <Box sx={{ flexGrow: 1, minHeight: 0, overflowY: tab === 'ask' ? 'hidden' : 'auto', borderTop: 1, borderColor: 'divider' }}>
        {tab === 'ask' ? <ReportAsk reportId={doc.id} title={doc.title} instrument={doc.currencies[0]} onPage={toPage} /> : null}
        {tab === 'summary' ? <SummaryTab doc={doc} onOpen={onOpen} /> : null}
        {tab === 'what-changed' ? <WhatChangedTab documentId={doc.id} series={doc.series} onOpenPage={toPage} /> : null}
      </Box>
    </Stack>
  );
}

const panelSx = {
  width: { xs: '100%', md: PANEL_WIDTH },
  flexShrink: 0,
  height: { xs: '80vh', md: 'auto' },
  bgcolor: 'background.paper',
  borderLeft: { md: 1 },
  borderTop: { xs: 1, md: 0 },
  borderColor: 'divider',
} as const;
